import { AuthApplicationKeys } from "@common/models/Enums";
import { ClientConfigurationModel, IClientConfigurationModel } from "@common/models/ClientConfigurationModel";
import { http } from "@common/utils";
import { trackPromise } from "react-promise-tracker";
import { ServiceHelper } from "./serviceHelper";
import { ServiceMethodOptions } from "./types";

export class ConfigurationService {
    private static baseUrl: string = '/api/configuration/';

    static tags = {
        getConfiguration: "getConfiguration"
    }

    static getConfiguration = (authApplicationKey: AuthApplicationKeys, options?: ServiceMethodOptions, isPublic: boolean = false): Promise<ClientConfigurationModel> => {
        const vpca = (isPublic) ? '?vpca=351BD313-2C19-442B-BC87-C69356EB59EF' : '';

        return trackPromise(new Promise<ClientConfigurationModel>((resolve, reject) => {
            http(`${this.baseUrl}${authApplicationKey}${vpca}`).get<IClientConfigurationModel>()
                .then((config) => {
                    ServiceHelper.showSuccess("Configuration Loaded: " + authApplicationKey.toString(), options);
                    resolve(new ClientConfigurationModel(config));
                })
                .catch((err) => {
                    ServiceHelper.showError("Failed to load configuration for: " + authApplicationKey.toString(), options);
                    reject(err);
                })
        }), this.tags.getConfiguration);
    };
}
